"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.MenuPaper = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIs = require("react-is");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _HTMLElementType = _interopRequireDefault(require("@mui/utils/HTMLElementType"));
var _RtlProvider = require("@mui/system/RtlProvider");
var _useSlotProps = _interopRequireDefault(require("@mui/utils/useSlotProps"));
var _MenuList = _interopRequireDefault(require("../MenuList"));
var _Popover = _interopRequireWildcard(require("../Popover"));
var _rootShouldForwardProp = _interopRequireDefault(require("../styles/rootShouldForwardProp"));
var _zeroStyled = require("../zero-styled");
var _DefaultPropsProvider = require("../DefaultPropsProvider");
var _menuClasses = require("./menuClasses");
var _useSlot = _interopRequireDefault(require("../utils/useSlot"));
var _jsxRuntime = require("react/jsx-runtime");
var RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
var LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, _composeClasses.default)(slots, _menuClasses.getMenuUtilityClass, classes);
};
var MenuRoot = (0, _zeroStyled.styled)(_Popover.default, {
    shouldForwardProp: function(prop) {
        return (0, _rootShouldForwardProp.default)(prop) || prop === 'classes';
    },
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        return styles.root;
    }
})({});
var MenuPaper = exports.MenuPaper = (0, _zeroStyled.styled)(_Popover.PopoverPaper, {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: function(props, styles) {
        return styles.paper;
    }
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
var MenuMenuList = (0, _zeroStyled.styled)(_MenuList.default, {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: function(props, styles) {
        return styles.list;
    }
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
var Menu = /*#__PURE__*/ React.forwardRef(function Menu(inProps, ref) {
    var props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    var _props_autoFocus = props.autoFocus, autoFocus = _props_autoFocus === void 0 ? true : _props_autoFocus, children = props.children, className = props.className, _props_disableAutoFocusItem = props.disableAutoFocusItem, disableAutoFocusItem = _props_disableAutoFocusItem === void 0 ? false : _props_disableAutoFocusItem, _props_MenuListProps = props.MenuListProps, MenuListProps = _props_MenuListProps === void 0 ? {} : _props_MenuListProps, onClose = props.onClose, open = props.open, _props_PaperProps = props.PaperProps, PaperProps = _props_PaperProps === void 0 ? {} : _props_PaperProps, PopoverClasses = props.PopoverClasses, _props_transitionDuration = props.transitionDuration, transitionDuration = _props_transitionDuration === void 0 ? 'auto' : _props_transitionDuration, tmp = props.TransitionProps, onEntering = (tmp === void 0 ? {} : tmp).onEntering, _props_variant = props.variant, variant = _props_variant === void 0 ? 'selectedMenu' : _props_variant, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, TransitionProps = _object_without_properties(props.TransitionProps, [
        "onEntering"
    ]), other = _object_without_properties(props, [
        "autoFocus",
        "children",
        "className",
        "disableAutoFocusItem",
        "MenuListProps",
        "onClose",
        "open",
        "PaperProps",
        "PopoverClasses",
        "transitionDuration",
        "TransitionProps",
        "variant",
        "slots",
        "slotProps"
    ]);
    var isRtl = (0, _RtlProvider.useRtl)();
    var ownerState = _object_spread_props(_object_spread({}, props), {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    var classes = useUtilityClasses(ownerState);
    var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    var menuListActionsRef = React.useRef(null);
    var handleEntering = function(element, isAppearing) {
        if (menuListActionsRef.current) {
            menuListActionsRef.current.adjustStyleForScrollbar(element, {
                direction: isRtl ? 'rtl' : 'ltr'
            });
        }
        if (onEntering) {
            onEntering(element, isAppearing);
        }
    };
    var handleListKeyDown = function(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) {
                onClose(event, 'tabKeyDown');
            }
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    React.Children.map(children, function(child, index) {
        if (!/*#__PURE__*/ React.isValidElement(child)) {
            return;
        }
        if (process.env.NODE_ENV !== 'production') {
            if ((0, _reactIs.isFragment)(child)) {
                console.error([
                    "MUI: The Menu component doesn't accept a Fragment as a child.",
                    'Consider providing an array instead.'
                ].join('\n'));
            }
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) {
                activeItemIndex = index;
            } else if (activeItemIndex === -1) {
                activeItemIndex = index;
            }
        }
    });
    var externalForwardedProps = {
        slots: slots,
        slotProps: _object_spread({
            list: MenuListProps,
            transition: TransitionProps,
            paper: PaperProps
        }, slotProps)
    };
    var rootSlotProps = (0, _useSlotProps.default)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    var _ref = _sliced_to_array((0, _useSlot.default)('paper', {
        className: classes.paper,
        elementType: MenuPaper,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        ownerState: ownerState
    }), 2), PaperSlot = _ref[0], paperSlotProps = _ref[1];
    var _ref1 = _sliced_to_array((0, _useSlot.default)('list', {
        className: (0, _clsx.default)(classes.list, MenuListProps.className),
        elementType: MenuMenuList,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: function(handlers) {
            return _object_spread_props(_object_spread({}, handlers), {
                onKeyDown: function(event) {
                    var _handlers_onKeyDown;
                    handleListKeyDown(event);
                    (_handlers_onKeyDown = handlers.onKeyDown) === null || _handlers_onKeyDown === void 0 ? void 0 : _handlers_onKeyDown.call(handlers, event);
                }
            });
        },
        ownerState: ownerState
    }), 2), ListSlot = _ref1[0], listSlotProps = _ref1[1];
    var resolvedTransitionProps = typeof externalForwardedProps.slotProps.transition === 'function' ? externalForwardedProps.slotProps.transition(ownerState) : externalForwardedProps.slotProps.transition;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MenuRoot, _object_spread_props(_object_spread({
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? RTL_ORIGIN : LTR_ORIGIN,
        slots: _object_spread({
            root: slots.root,
            paper: PaperSlot,
            backdrop: slots.backdrop
        }, slots.transition && {
            // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
            transition: slots.transition
        }),
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps,
            backdrop: typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop,
            transition: _object_spread_props(_object_spread({}, resolvedTransitionProps), {
                onEntering: function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var _resolvedTransitionProps_onEntering;
                    var _resolvedTransitionProps_onEntering1;
                    handleEntering.apply(void 0, _to_consumable_array(args));
                    resolvedTransitionProps === null || resolvedTransitionProps === void 0 ? void 0 : (_resolvedTransitionProps_onEntering1 = resolvedTransitionProps.onEntering) === null || _resolvedTransitionProps_onEntering1 === void 0 ? void 0 : (_resolvedTransitionProps_onEntering = _resolvedTransitionProps_onEntering1).call.apply(_resolvedTransitionProps_onEntering, [
                        resolvedTransitionProps
                    ].concat(_to_consumable_array(args)));
                }
            })
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        ownerState: ownerState
    }, other), {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListSlot, _object_spread_props(_object_spread({
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, listSlotProps), {
            children: children
        }))
    }));
});
process.env.NODE_ENV !== "production" ? Menu.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */ anchorEl: _propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        _HTMLElementType.default,
        _propTypes.default.func
    ]),
    /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */ autoFocus: _propTypes.default.bool,
    /**
   * Menu contents, normally `MenuItem`s.
   */ children: _propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */ disableAutoFocusItem: _propTypes.default.bool,
    /**
   * Props applied to the [`MenuList`](https://mui.com/material-ui/api/menu-list/) element.
   * @deprecated use the `slotProps.list` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */ MenuListProps: _propTypes.default.object,
    /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */ onClose: _propTypes.default.func,
    /**
   * If `true`, the component is shown.
   */ open: _propTypes.default.bool.isRequired,
    /**
   * @ignore
   */ PaperProps: _propTypes.default.object,
    /**
   * `classes` prop applied to the [`Popover`](https://mui.com/material-ui/api/popover/) element.
   */ PopoverClasses: _propTypes.default.object,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: _propTypes.default.shape({
        backdrop: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        list: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        paper: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        root: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        transition: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: _propTypes.default.shape({
        backdrop: _propTypes.default.elementType,
        list: _propTypes.default.elementType,
        paper: _propTypes.default.elementType,
        root: _propTypes.default.elementType,
        transition: _propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ]),
    /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */ transitionDuration: _propTypes.default.oneOfType([
        _propTypes.default.oneOf([
            'auto'
        ]),
        _propTypes.default.number,
        _propTypes.default.shape({
            appear: _propTypes.default.number,
            enter: _propTypes.default.number,
            exit: _propTypes.default.number
        })
    ]),
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */ TransitionProps: _propTypes.default.object,
    /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */ variant: _propTypes.default.oneOf([
        'menu',
        'selectedMenu'
    ])
} : void 0;
var _default = exports.default = Menu;
